// Deep-linking helpers: map between the URL path and a scheduling thread's AVP id.
// A shareable link like https://dev.aspen.appsec.aws.dev/AVP-12345 opens that thread.

const AVP_PATH_RE = /^\/([A-Za-z]+-\d+)\/?$/;

/** Returns the AVP id encoded in the current URL path, or null if none. */
export function avpFromPath(): string | null {
  const match = window.location.pathname.match(AVP_PATH_RE);
  return match && match[1] ? match[1].toUpperCase() : null;
}

/**
 * Reflect the currently open thread in the URL so the link is shareable.
 * Pass the thread's AVP id to point at it, or null to return to the root.
 */
export function setPathForAvp(avpId: string | null): void {
  const path = avpId ? `/${avpId}` : '/';
  if (window.location.pathname !== path) {
    window.history.pushState(null, '', path);
  }
}
